module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/left-circle-b1919b230a47d75af858ce3586d4897e.svg";